export default function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/ramda/es/internal/_containsWith.js
// module id = ../node_modules/ramda/es/internal/_containsWith.js
// module chunks = 5